import { render } from "./OurTestimonial.vue?vue&type=template&id=47f48aeb"
import script from "./OurTestimonial.vue?vue&type=script&lang=js"
export * from "./OurTestimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__